import '../../style/style.css';
function Cabecalho() {



    return (

        <main>

            <div className="cabecalhoBlog">

                <div><img src={'https://somosconexaosocial.org/site_img/blog-rebeca/cabecalho-foto.jpg'} alt="Techfest 2025" /></div>

                <div className='nomeDescricao'>

                    <h1>Blog Rebeca Lima</h1>

                    <p>Meu nome é Rebeca Lima, tenho 16 anos e sou uma adolescente cheia de energia e sonhos. Resido na encantadora cidade de Lagoa de Itaenga, no Pernambuco, estou no ensino médio, um período que considero essencial para moldar meu futuro e explorar novas oportunidades. Fui aluna do projeto Passaporte Digital, tive a honra de participar do programa Intercâmbio dos Saberes, dentro do projeto Passaporte Digital, o que foi uma experiência transformadora. Atualmente, estou como jovem aprendiz na Associação Conexão Social (ACS), onde estou vivenciando uma experiência enriquecedora que tem contribuído significativamente para o meu crescimento pessoal e profissional.</p>


                </div>

                

                

            </div>

        </main>

        


    );
}

export default Cabecalho;